import React from 'react';

function Contact({ handleMouseMove, handleMouseLeave }) {
  return (
    <section id="contact" className="bg-gradient-to-r from-gray-900 via-gray-950 to-gray-900 py-32 border-t border-yellow-600/20 min-h-screen flex items-center">
      <div className="luxury-container w-full text-center">
        <h2 className="text-luxury text-5xl mb-6 tracking-widest hover-glow">
          GET IN TOUCH
        </h2>
        <p className="text-gray-400 text-lg mb-12 tracking-wide hover-glow">
          Visit our showroom or contact us for custom designs and exclusive collections
        </p>
        <button 
          className="bg-gradient-to-r from-yellow-600 to-yellow-700 hover:from-yellow-500 hover:to-yellow-600 text-gray-900 px-10 py-4 rounded-sm font-bold text-lg tracking-widest transform-gpu transition-transform duration-75 cursor-pointer depth-effect"
          onMouseMove={(e) => handleMouseMove(e, e.currentTarget)}
          onMouseLeave={(e) => handleMouseLeave(e?.currentTarget)}
        >
          CONTACT US
        </button>
      </div>
    </section>
  );
}

export default Contact;
